import { relationships } from "@rocicorp/zero";
import { crew } from "./crew";
import { project } from "./project";
import { ticket } from "./ticket";
import { ticketAssignment } from "./ticket-assignment";
import { ticketAssignmentReference } from "./ticket-assignment-reference";

export const ticketAssignmentRelationships = relationships(ticketAssignment, ({ one }) => ({
	ticket: one({
		sourceField: ["ticketId"],
		destField: ["id"],
		destSchema: ticket,
	}),
	crew: one({
		sourceField: ["crewId"],
		destField: ["id"],
		destSchema: crew,
	}),
	project: one({
		sourceField: ["projectId"],
		destField: ["id"],
		destSchema: project,
	}),
	reference: one({
		sourceField: ["referenceId"],
		destField: ["id"],
		destSchema: ticketAssignmentReference,
	}),
}));
